import { useState, useEffect, useRef } from 'react';

const useIntersectionObserver = (sectionIds) => {
  const [activeSection, setActiveSection] = useState(null);
  const observer = useRef(null);

  useEffect(() => {
    observer.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0.6, // Adjust this value as needed (e.g., 0.5 means when 50% of the element is visible)
      }
    );

    sectionIds.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        observer.current.observe(element);
      }
    });

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [sectionIds]);

  return activeSection;
};

export default useIntersectionObserver;
